/* eslint-disable max-classes-per-file */
import {
  DataSendMailVerificationPresenter,
  DataSendSMSVerificationPresenter,
} from "@/libs/client/goApi/profile/profileServiceInterface/responseProfileInterface";
import type { LoginStepEnums } from "@/types/product/account/authentication";
import { LoginTypeEnums } from "@/types/product/account/authentication";

export interface HandleStepProps {
  handleStep: (val: LoginStepEnums) => void;
  handleBackStep: () => void;
  handleClose: () => void;
}
export interface HandleDataLoginProps {
  dataLogin: DataHandleLoginClass;
  handleDataLogin: (val: DataHandleLoginClass) => void;
}

export class DataHandleLoginClass {
  email: string;

  token: string;

  lastSocialLoginType: string;

  accountId: string; // NOTE - ใช้ในกรณีมี socail แต่เข้ามาด้วย email ต้องยิ่งเส้น postSavePassword ไม่ได้ return data account มาด้วย

  isHaveSocial: boolean; // NOTE - เข้ามาจาก ปุ่ม email แต่มี socail แล้ว

  isHavePassword: boolean; // NOTE - เข้ามาจาก ปุ่ม socail แต่มี password แล้ว

  isSyncSocail: boolean; // NOTE - เข้ามาจาก ปุ่ม socail แต่มี socail อื่นแล้ว

  dataSendSmsCode: DataSendSMSVerificationPresenter;

  dataSendMailCode: DataSendMailVerificationPresenter;

  otpCode: string;

  refCode: string;

  bookingInternalNo: string;

  constructor(data: any) {
    this.email = data?.email || "";
    this.token = data?.token || "";
    this.lastSocialLoginType = data?.socialType || LoginTypeEnums.EMAIL;
    this.accountId = data?.social?.[0]?.accountId || "";
    this.isHaveSocial = data?.isHaveSocial || false;
    this.isHavePassword = data?.isHavePassword || false;
    this.isSyncSocail = data?.isSyncSocail || false;
    this.dataSendSmsCode = new DataSendSMSVerificationPresenter(
      data?.dataSendSmsCode,
    );
    this.dataSendMailCode = new DataSendMailVerificationPresenter(
      data?.dataSendMailCode,
    );
    this.otpCode = data?.otp_code || "";
    this.refCode = data?.ref_code || "";
    this.bookingInternalNo = data?.bookingInternalNo || "";
  }
}
